import LegalLayout from "@/components/LegalLayout";

const SECTIONS = [
  {
    heading: "Overview",
    body: [
      "This Refund Policy explains when and how you may request a refund for payments made to Radio App Consultancy. By completing a payment, you acknowledge that you have read and agree to this policy.",
    ],
  },
  {
    heading: "One-Time Service Charges",
    body: [
      "Payments made through this website are one-time service charges for the consultation or development service you select. We do not offer subscriptions and will not bill you again unless you place a new order.",
    ],
  },
  {
    heading: "15-Day Free-Fix Guarantee",
    body: [
      "Every project includes a 15-day guarantee. If you experience any issue after your delivery within these 15 days, contact us and we will fix it free of charge — no extra payment required.",
      "To report an issue, email akarjagdev@gmail.com or call (864) 481-0776 with your payment ID and the email used at checkout.",
    ],
  },
  {
    heading: "Refund Eligibility",
    body: [
      "You may request a refund within 7 days of payment if the consultation/development service has not yet been started or delivered.",
      "If a genuine issue during your 15-day guarantee cannot be resolved by us, you may request a refund for the affected service.",
    ],
  },
  {
    heading: "Non-Refundable Situations",
    body: [
      "Once the consultation/development service has been completed and delivered as described (and any 15-day guarantee issues resolved), the one-time service charge is generally non-refundable, as the service has already been rendered.",
      "Amounts you chose to pay above a listed service price (for example, a custom amount) are treated the same as the service payment.",
    ],
  },
  {
    heading: "How Refunds Are Processed",
    body: [
      "Approved refunds are issued back to your original payment method through Razorpay or PayPal, depending on how you paid. Depending on your bank, it may take 5–10 business days for the amount to reflect.",
    ],
  },
  {
    heading: "Chargebacks",
    body: [
      "Please contact us before initiating a chargeback with your bank. Most concerns can be resolved directly and faster through our support team.",
      "For payments you authorized and where the service was delivered, we may contest chargebacks by providing proof of your consent and the service rendered.",
    ],
  },
];

export default function Refund() {
  return (
    <LegalLayout
      title="Refund Policy"
      updated="June 2026"
      intro="We want you to be satisfied. This policy outlines how refunds work for services purchased from Radio App Consultancy."
      sections={SECTIONS}
    />
  );
}
